module.exports = __webpack_public_path__ + "r-v3/img/eraser_clear_white.8c440cbb.svg";